import { Property } from "./interfaces";

export const codDiagnosticoPrincipalE: Property = {
    title: "Código de Diagnóstico Principal E",
    type: "string"
}